import React, { useEffect, useState } from "react";
import TicketDetails from "../Popups/TicketDetails/TicketDetails";
import { useTheme } from '@mui/material';
import { tokens } from "../../../../../theme";
import "./TicketStatus.css";

const TicketCard: React.FC<{ ticket: any }> = ({ ticket }) => {
    const [modalOpen, setModalOpen] = useState(false);
    const handlePopUpChange = () => {
        setModalOpen(!modalOpen);
    };

    const theme = useTheme(); // Access the current theme
    const colors = tokens(theme.palette.mode);

    useEffect(() => {
        // Set CSS variables based on the current theme colors
        document.documentElement.style.setProperty('--header-bg-color', colors.headers.backround);
        document.documentElement.style.setProperty('--header-text-color', colors.headers.text);
        document.documentElement.style.setProperty('--box-shadow', colors.headers.boxShadow);

    }, [theme]);

    return (
        <>
            {(
                <div
                    className="card listCard shadow-sm"
                >
                    <div className="card_header">
                        <div
                            style={{
                                padding: "8px 16px", backgroundColor:
                                    ticket.state === "New" ? colors.primary[500] : colors.grey[500],
                                color: 'white'
                            }}

                            className='badge rounded-pill'
                        >{ticket.state}</div>
                        <p style={{ margin: 0, fontSize: '12px' }}>
                            Pending with:{" "}
                            {ticket.assignment_group
                                ? ticket.assignment_group
                                : "No Assignment Group"}
                        </p>
                    </div>
                    <hr style={{ margin: "16px 0px" }} />
                    <div className="flex req_background">
                        <div>
                            <div>
                                <p style={{ margin: 0, color: 'var(--header-text-color)' }}>
                                    {ticket.number}: {ticket.short_description}
                                </p>
                            </div>
                        </div>
                        {ticket.state === "New" || ticket.state === "In Progress" ? (
                            <>
                                <div>
                                    <button
                                        onClick={handlePopUpChange}
                                        className="btn btn-primary"
                                        style={{ gap: "8px" }}
                                    >
                                        <div className="update_btn"></div>
                                        Update
                                    </button>
                                    {modalOpen && (
                                        <TicketDetails
                                            modalOpen={modalOpen}
                                            setModalOpen={setModalOpen}
                                            ticketDetails={ticket}
                                        />
                                    )}
                                </div>
                            </>
                        ) : null}
                    </div>
                </div>
            )}
        </>
    );
};

export default TicketCard;
